import BanquesController from './banques.controller';

export default {
    template: require('./banques.tpl.html'),
    controller: BanquesController
};
